module.exports = __webpack_public_path__ + "Flag-328.75166e67d85de6d58755bcfcd11d8537.svg";